import { render } from "./Appointment.vue?vue&type=template&id=2bd0b736&scoped=true"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"

import "./Appointment.vue?vue&type=style&index=0&id=2bd0b736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd0b736"]])

export default __exports__